<template>
  <b-card class="agent__details">
    <b-row>
      <b-col md="12">
        <b-card class="has-padding">
          <b-card-title class="d-flex justify-content-between align-items-center mb-2">
            <span>
              Agent Details
              <b-badge
                variant="light-info"
                class="ml-50"
              >
                {{ roleLabel }}
              </b-badge>
            </span>
            <span>
              <b-button
                v-if="(roleLabel === 'Service Agent' || roleLabel === 'Sales Agent') && canViewThisAction(permissionAction, permissionResource)"
                variant="flat-primary"
                @click="$emit('change-agent')"
              >
                <feather-icon
                  icon="EditIcon"
                  class="mr-50"
                />
                Change
              </b-button>
              <b-button
                v-if="canViewThisAction('update', 'Agent')"
                variant="flat-primary"
                :to="{
                  name: agentType === 'ProbationaryAgent' ? 'agency-agents-probationary-edit' : 'agency-agents-edit',
                  params: { id: agentDetail._id },
                  query: { redirect: $route.fullPath },
                }"
              >
                <feather-icon
                  icon="EditIcon"
                  class="mr-50"
                />
                Edit
              </b-button>
            </span>
          </b-card-title>
          <b-card-body>
            <b-row>
              <b-col
                md="2"
                class="d-flex align-self-center"
              >
                <b-avatar
                  size="150"
                  :src="agentDetail.image"
                  :text="resolveAcronymName(agentDetail.name)"
                />
              </b-col>
              <b-col md="5">
                <b-table-simple
                  borderless
                  responsive
                  class="particulars_of_deceased d-none d-md-block"
                >
                  <b-tbody>
                    <b-tr>
                      <b-th width="230px">
                        Agent Name
                      </b-th>
                      <b-td>
                        <b-button
                          v-if="canViewThisAction('show', 'Agent') && agentDetail._id"
                          v-ripple.400="'rgba(30, 30, 30, 0.15)'"
                          variant="link"
                          class="p-0 weight-600 align-middle"
                          :to="{
                            name: agentType === 'ProbationaryAgent' ? 'agency-agents-probationary-show' : 'agency-agents-show',
                            params: { id: agentDetail._id },
                          }"
                        >
                          {{ agentDetail.name || '-' }}
                        </b-button>
                        <span v-else>{{ agentDetail.name || '-' }}</span>
                      </b-td>
                    </b-tr>
                    <b-tr>
                      <b-th width="230px">
                        Card Display Name
                      </b-th>
                      <b-td>{{ agentDetail.displayName || '-' }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-th width="230px">
                        Agent Code
                      </b-th>
                      <b-td>{{ agentDetail.code || '-' }}</b-td>
                    </b-tr>
                    <b-tr v-if="agentType === 'ProbationaryAgent'">
                      <b-th width="230px">
                        Agency
                      </b-th>
                      <b-td>
                        <span v-if="agentDetail.agent">{{ `${agentDetail.agent.agencyName || '-'} (${agentDetail.agent.agencyCode || '-'}) - ${agentDetail.agent.agencyState || '-'}` }}</span>
                        <span v-else>-</span>
                      </b-td>
                    </b-tr>
                    <b-tr v-if="agentType === 'ProbationaryAgent'">
                      <b-th width="230px">
                        Agent (Upline)
                      </b-th>
                      <b-td>
                        <span v-if="agentDetail.agent">{{ agentDetail.agent.name }} ({{ agentDetail.agent.code }})</span>
                        <span v-else>-</span>
                      </b-td>
                    </b-tr>
                    <b-tr v-else>
                      <b-th width="230px">
                        Agency
                      </b-th>
                      <b-td>{{ `${agentDetail.agencyName || '-'} (${agentDetail.agencyCode || '-'}) - ${agentDetail.agencyState || '-'}` }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-th width="230px">
                        Country Code
                      </b-th>
                      <b-td>{{ agentDetail.country || '-' }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-th width="230px">
                        State Code
                      </b-th>
                      <b-td>{{ agentDetail.state || '-' }}</b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </b-col>
              <b-col md="5">
                <b-table-simple
                  borderless
                  responsive
                  class="particulars_of_deceased d-none d-md-block"
                >
                  <b-tbody>
                    <b-tr>
                      <b-th width="230px">
                        Join Date
                      </b-th>
                      <b-td>{{ agentDetail.joinDate ? dateFormat(agentDetail.joinDate) : '-' }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-th width="230px">
                        Confirm Date
                      </b-th>
                      <b-td>{{ agentDetail.confirmDate ? dateFormat(agentDetail.confirmDate) : '-' }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-th width="230px">
                        Expiry Date
                      </b-th>
                      <b-td>{{ agentDetail.expDate ? dateFormat(agentDetail.expDate) : '-' }}</b-td>
                    </b-tr>
                    <b-tr v-if="agentType !== 'ProbationaryAgent'">
                      <b-th width="230px">
                        Rank
                      </b-th>
                      <b-td>{{ agentDetail.rank }}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-th width="230px">
                        Status
                      </b-th>
                      <b-td><span :class="agentDetail.status == 'Active' ? 'text-success' : 'text-danger'">{{ agentDetail.status }}</span></b-td>
                    </b-tr>
                    <b-tr>
                      <b-th width="230px">
                        Remarks
                      </b-th>
                      <b-td>{{ agentDetail.remark || '-' }}</b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="match-height">
      <b-col md="4">
        <b-card class="has-padding agent-detail-spaced-card">
          <b-card-title class="mb-2">
            Personal Information
          </b-card-title>
          <b-card-body>
            <b-table-simple
              borderless
              responsive
              class="particulars_of_deceased d-md-block"
            >
              <b-tbody>
                <b-tr>
                  <b-th width="120px">
                    NRIC
                  </b-th>
                  <b-td>
                    <div v-if="showFullNric">
                      <span class="mr-50">{{ agentDetail.nricNew || agentDetail.nric }}</span>
                      <b-button
                        variant="primary"
                        size="sm"
                        class="px-50"
                        @click="showFullNric = false"
                      >
                        Hide full NRIC
                      </b-button>
                    </div>
                    <div v-else>
                      <span class="mr-50">{{ agentDetail.encryptedNric }}</span>
                      <b-button
                        v-if="canViewThisAction('view-nric', 'NRIC')"
                        variant="primary"
                        size="sm"
                        class="px-50"
                        @click="showFullNric = true"
                      >
                        Show full NRIC
                      </b-button>
                    </div>
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="120px">
                    Sex
                  </b-th>
                  <b-td>{{ agentDetail.sex || '-' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="120px">
                    Race
                  </b-th>
                  <b-td>{{ agentDetail.race || '-' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="120px">
                    Marital
                  </b-th>
                  <b-td>{{ agentDetail.maritalStatus || '-' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="120px">
                    Date of Birth
                  </b-th>
                  <b-td>{{ agentDetail.dob ? dateFormat(agentDetail.dob) : '-' }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col md="4">
        <b-card class="has-padding agent-detail-spaced-card">
          <b-card-title class="mb-2">
            Correspondence Contact
          </b-card-title>
          <b-card-body>
            <b-table-simple
              borderless
              responsive
              class="particulars_of_deceased d-md-block"
            >
              <b-tbody>
                <b-tr>
                  <b-th width="230px">
                    Primary Contact
                  </b-th>
                  <b-td>{{ agentDetail.personalContact || agentDetail.contact || '-' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Secondary Contact
                  </b-th>
                  <b-td>{{ agentDetail.homeContact || '-' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Email Address
                  </b-th>
                  <b-td>{{ agentDetail.email || agentDetail.sclcEmail || '-' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Address
                  </b-th>
                  <b-td>{{ [agentDetail.address1, agentDetail.address2, agentDetail.address3].filter(Boolean).join(', ') || '-' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Post Code
                  </b-th>
                  <b-td>{{ agentDetail.postCode || '-' }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col md="4">
        <b-card class="has-padding">
          <b-card-title class="mb-2">
            Emergency Contact
          </b-card-title>
          <b-card-body>
            <b-table-simple
              borderless
              responsive
              class="particulars_of_deceased d-md-block"
            >
              <b-tbody>
                <b-tr>
                  <b-th width="230px">
                    Emergency Contact Person
                  </b-th>
                  <b-td>{{ agentDetail.emergencyContactName || '-' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Mobile No.
                  </b-th>
                  <b-td>{{ agentDetail.emergencyContactMobile || '-' }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Relationship
                  </b-th>
                  <b-td>{{ agentDetail.emergencyContactRelation || '-' }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-card-body>
        </b-card>
        <b-card class="has-padding agent-detail-spaced-card">
          <b-card-title class="mb-2">
            Agent’s Bank Details
          </b-card-title>
          <b-card-body>
            <b-table-simple
              borderless
              responsive
              class="particulars_of_deceased d-md-block"
            >
              <b-tbody>
                <b-tr>
                  <b-th width="230px">
                    Bank Code
                  </b-th>
                  <b-td>{{ agentDetail.bankCode }} - {{ agentDetail.bankName }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Bank Branch
                  </b-th>
                  <b-td>{{ agentDetail.bankBranch }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230px">
                    Bank Account No.
                  </b-th>
                  <b-td>{{ agentDetail.bankAccountNo }}</b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BRow, BCol, BCard, BCardTitle, BCardBody, BTableSimple, BTbody, BTr, BTh, BTd, BAvatar, BButton, BBadge,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { useUtils as useAclUtils } from '@/libs/acl/custom'

export default {
  components: {
    BRow, BCol, BCard, BCardTitle, BCardBody, BTableSimple, BTbody, BTr, BTh, BTd, BAvatar, BButton, BBadge,
  },
  directives: {
    Ripple,
  },
  props: {
    agentDetail: {
      type: Object,
      required: true,
    },
    agentType: {
      type: String,
      default: 'Agent',
    },
    roleLabel: {
      type: String,
      default: 'Sales Agent',
    },
    permissionResource: {
      type: String,
      default: 'SalesSubmission',
    },
    permissionAction: {
      type: String,
      default: 'update',
    },
  },
  setup() {
    const { canViewThisAction } = useAclUtils()
    return { canViewThisAction }
  },
  data() {
    return {
      showFullNric: false,
    }
  },
  methods: {
    resolveAcronymName(name) {
      if (name) {
        return name.split(' ').map(item => item.charAt(0)).join('').toUpperCase()
      }
      return ''
    },
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/pages/app-email.scss";
.agent__details {
  background-color: #F8F8F8;
  margin-bottom: 1.5rem;

  // .has-padding (_calllog.scss) already puts 20px padding on the .card itself; b-card-body's own
  // default Bootstrap padding stacks on top of that, doubling the gap under the title. Scoped to
  // .agent__details so it doesn't touch .has-padding cards on other pages (e.g. AgentDetail.vue).
  // .content-body .card .card .card-body { padding: 15px 0 0 !important } (_common.scss) otherwise
  // wins on specificity/!important.
  .card.has-padding .card-body {
    padding: 0 !important;
  }

  // Personal Information / Correspondence Contact / Bank Details only - not Emergency Contact
  // (sits directly above Bank Details in the same column, no gap needed) or the Agent Details
  // card above (its own row already has spacing from match-height's row gutter).
  .card.has-padding.agent-detail-spaced-card {
    margin-bottom: 0rem !important;
  }
}
</style>
